export enum OpacityConstants{
    CurrentOpacity = "0d04d8e0-e51a-4f2e-8d9f-2de87e9e5d26",
    Resurfacer = "3f4cc1b4-98bd-4818-bf26-b290ed2db1a3"
}


// WEBPACK FOOTER //
// ./src/app/models/opacity-constants.enum.ts